import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'value-added-programme',
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class ValueAddedProgramComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
